import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Button} from '@chakra-ui/react';
import { formatISO } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faFileImport} from "@fortawesome/free-solid-svg-icons";

import Papa from "papaparse";

import LocalStorageService from "../../services/LocalStorageService";

import LookupEntityManager from "../../pages/Observation/Components/Managers/LookupEntityManager";
import { Table, TableContainer, Thead, Tbody, Tr, Td, Th} from "@chakra-ui/react";

import JwtToken from "../../components/lib/tokens/JwtToken";

const SCHEMA_COLUMN = "Schema";

export default class CsvParserDialog extends Component 
{
  constructor() {
    super();
    this.state = {
      csvFileName: null,
      parsedResult: null,
      hasImportErrors: false,
      errMsg: "",
      loading: false,
      saving: false
    };

    this.onFileImportRequest = this.onFileImportRequest.bind(this);
    this.onOkButtonClick = this.onOkButtonClick.bind(this);
    this.init = this.init.bind(this);
    this.onCloseRequest = this.onCloseRequest.bind(this);
    
  }

  async componentDidUpdate(prevProps, prevState)
  {
    if (prevProps.show !== this.props.show)
    {
      if (this.props.show)
      {
        await this.init();
      }
    }
  }

  async init()
  {

  }

  onCloseRequest()
  {
    this.setState({csvFileName: "", parsedResult: null, errMsg: "", loading: false, saving: false, hasImportErrors: false});
    this.props.onCloseRequest();
  }


  async onFileImportRequest(event)
  {
    var that = this;
    this.setState({csvFileName: event.target.files[0].name});
    Papa.parse(event.target.files[0], {
        header: true,
        skipEmptyLines: true,
        complete: function (results) 
        {
          var nonEmptyData = results.data.filter(d => d["Commodity"] !== "");
          results.data = nonEmptyData;
          var hasImportErrors = ((results.errors) && (results.errors.length > 0));
          that.setState({parsedResult: results, hasImportErrors: hasImportErrors});
        },
      });
  }


  static ToFieldTypeValue(val, fieldType, fieldTypeSchema)
  {
    var typ = (fieldType) ? fieldType.toLowerCase() : "string";
    switch (typ)
    {
      case 'int': return parseInt(val);
      case 'date': return formatISO(new Date(val));
      case 'multientrykeypair':
          var formattedVal = {};
          formattedVal[fieldTypeSchema.keyProp] = (fieldTypeSchema.fillProp === "keyProp") ? val : "";
          formattedVal[fieldTypeSchema.valueProp] = (fieldTypeSchema.fillProp === "valueProp") ? val : "";
          return formattedVal;
      default: return val;

    }
  }

  static ToUniqueSchemaIds(rawLines)
  {
    var uniqueSchemaIds = [];
    for(const ln of rawLines) 
    {
      var schemaId = ln[SCHEMA_COLUMN];
      if (schemaId !== "")
      {
        if (!uniqueSchemaIds.includes(schemaId))
        {
          uniqueSchemaIds.push(schemaId);
        }
      }
    }
    return uniqueSchemaIds;
  }

  static async ToUniqueSchemas(rawLines)
  {
    var uniqueSchemaIds = [];
    var uniqueSchemas = {};
    for(const ln of rawLines) 
    {
      var schemaId = ln[SCHEMA_COLUMN];
      if (schemaId !== "")
      {
        if (!uniqueSchemaIds.includes(schemaId))
        {
          uniqueSchemaIds.push(schemaId);
          uniqueSchemas[schemaId] = await new LocalStorageService().getSchema(schemaId);
        }
      }
    }
    return uniqueSchemas;
  }

  static MakeLookupEntityEntry(src, importRulesSchema)
  {
    var result = {};
    importRulesSchema.map.forEach((prop)=>
    {
      var val = src[prop.importProp];
      if (prop.fieldType)
      {
        // must be something special?
        var tempVal = CsvParserDialog.ToFieldTypeValue(val, prop.fieldType, prop);
        // sometimes these are arrays. Currently only one type is
        val = (prop.fieldType === "multientrykeypair") ? [tempVal] : tempVal;
      }
      result[prop.schemaProp] = val;
    });
    return result;
  }





  async onOkButtonClick(e) 
  {
    e.preventDefault();
    e.stopPropagation();
    if (!this.state.parsedResult)
    {
      this.setState({errMsg: "Select a file to import."})
      return;
    }
    this.setState({
      errMsg: "",
      saving: true
    });

    try
    {
      // start by getting the schemas we need
      var uniqueSchemaIds = CsvParserDialog.ToUniqueSchemaIds(this.state.parsedResult.data);
      // confirm the user has ACCESS to all of these schemas
      if (!JwtToken.hasAllSchemas(this.props.userSession.token, uniqueSchemaIds)) throw new Error("Import File contains schemas that you do not have access to. ");
      var uniqueSchemas = await CsvParserDialog.ToUniqueSchemas(this.state.parsedResult.data);

      var result = [];
      this.state.parsedResult.data.forEach((ln) => 
      {
        // first thing we need to do is figure out what schema this is! EVERY import must have a schema column
        if (ln[SCHEMA_COLUMN] === "") { 
          return;
          // throw new Error("Import File does not have a Schema column defined. Cannot continue import.");
      }
        var schemaId = ln[SCHEMA_COLUMN];
        const entityKeyReadOnly = false;
        if (!uniqueSchemaIds.includes(schemaId)) throw new Error("Unable to identify a schema with value " + schemaId + ". Cannot continue import.");
        var entitySchema = LookupEntityManager.getEntitySchemaFromSchema(uniqueSchemas[schemaId], this.props.entityLookupKeyId, entityKeyReadOnly);
        var entityCardSchema = LookupEntityManager.findCard(uniqueSchemas[schemaId], this.props.entityLookupKeyId);
        // test for blank line
          if (entityCardSchema.lookupEntity.import?.emptyLineRules?.removeLineOnEmpty)
          {
            if (ln[entityCardSchema.lookupEntity.import.emptyLineRules.emptyTestColumn].trim() === "")
            {
              return; // this acts like a continue with forEach loop
            }
          }

          // test if this has a COLLAPSE column (we only support ONE collapse column and one collapse prop)
          // collapse Is like a Pivot - If the value in the collapseOnColumn already exists, then we ignore all other fields and take the
          // value from the collapseOnColumn and look for it. If it exists, then we add it as an array element to the collapseToProp. 
          // We have a special case with multientrykeypair types because they have a key and a value and we may be assigning the value to one
          // or the other. This is driven by the Supplier Pallet Tag card as a special case. 
          if (entityCardSchema.lookupEntity.import?.collapseRules)
          {
            var collapseRules = entityCardSchema.lookupEntity.import.collapseRules;
            var existingCollapseTarget = result.find((r) => r.Data.find((f) => (f.Id === collapseRules.collapseOnProp && f.Value=== ln[collapseRules.collapseOnColumn])));
            if (existingCollapseTarget)
            {
              var val = ln[collapseRules.collapseToValueColumn];
              var fieldTypeSchema = entityCardSchema.lookupEntity.import.map.find((m) => m.schemaProp === collapseRules.collapseToProp); 
              val = CsvParserDialog.ToFieldTypeValue(val, collapseRules.collapseToType, fieldTypeSchema);
              // we assume this is an array since all collapsible values must be an array
              var cProp = existingCollapseTarget.Data.find((t) =>t.Id === collapseRules.collapseToProp);
              cProp.Value.push(val);
              /// now check for accumulators. We ASSUME these are integers currently. We will have to modify to support other types of accumulators
              // and operations (e.g. average, mean, or even array of values)
              if (collapseRules.accumulators)
              {
                collapseRules.accumulators.forEach((acc) => {
                  var accProp = existingCollapseTarget.Data.find((t) => t.Id === acc.accumulateToProp);
                  // tbd - what happens if it doesn't exist? 
                  var newVal = ln[acc.accumulateOnColumn];
                  var existingVal = accProp.Value;
                  // val
                  accProp.Value = (parseInt(existingVal) + parseInt(newVal));
                });
              }
              return; // works like continue. We do NOT want to process this as a new ROW because we just add it to the collapse target array
            }
          }
          
          var entity = CsvParserDialog.MakeLookupEntityEntry(ln, entityCardSchema.lookupEntity.import);
          var lookupEntityBag = {};
          lookupEntityBag[this.props.entityLookupKeyId] = ln[entityCardSchema.lookupEntity.import.entityKeyColumn];  //ln["Famous Lot Number"];
          var lookupEntities = LookupEntityManager.toLookupEntityList(lookupEntityBag, entity, uniqueSchemas[schemaId], this.props.userSession.gcid, this.props.userSession.uid);
          result.push(lookupEntities[0]);

      })
      await this.props.onPostRequest(result);
    }
    catch(e)
    {
      var errMsg = "Problem converting file to lookup entity (" + e.message + ")";
      this.setState({errMsg: errMsg});
    }
    finally 
    {
      this.setState({saving: false});
    }
  }

  render() {
    //console.info(this.props.dataRow);

    const savingDiv = (this.state.saving) ?
    <div><FontAwesomeIcon icon={faSyncAlt} spin={true} color={"green"}/>&nbsp; Saving...</div>
    : "";



    return (

      (this.props.isOpen) ?
      <Modal
        isOpen={this.props.isOpen} 
        onClose={this.props.onCloseRequest}
        scrollBehavior='inside'
      >
        <ModalOverlay/>
        <ModalContent minW={(this.state.parsedResult) ? "75vw" : "30vw"}>
        <ModalHeader closeButton>
          {this.props.title}
        </ModalHeader>
        <ModalBody>
        <Row><Col>Filename  : {(this.state.csvFileName) ? this.state.csvFileName: "Select File"}</Col></Row>
        <Row>&nbsp;</Row>
          <Row>
            <Col>
                <Button id="import-button" colorScheme='blue' mr={3}>
              <input type="file" id="files" style={{ display: "none" }} accept="application/csv" multiple="false" onChange={(e) => this.onFileImportRequest(e)}></input>
              <label classname={"icon-circle"} for="files"><FontAwesomeIcon id="fileMode" icon={faFileImport} />~Get File</label>
            </Button>
         
            </Col>
          </Row>
          {/*k
          {(this.state.parsedResult) &&
          <Row>
            <Col>

                    <JsonViewer
                        value={this.state.parsedResult.data}
                    />

            </Col>
          </Row>
          }
        */}

        {(this.state.parsedResult) &&
        <TableContainer>
          <Table>
            <Thead>
              <Tr>
                {this.state.parsedResult.meta.fields.map((h) => <Th>{h}</Th>)}
              </Tr>
            </Thead>
            <Tbody>
              {this.state.parsedResult.data.map(item => 
                <Tr>
                  {Object.keys(item).map(col => <Td>{item[col]}</Td>)}
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        }

        {(this.state.parsedResult?.errors) && (this.state.parsedResult.errors.length>0) && 
        <TableContainer>
          <Table>
            <Thead>
              <Tr>
              <Th color={"red"}>Errors</Th>
              </Tr>
            </Thead>
            <Tbody>
              {this.state.parsedResult.errors.map(item => 
                <Tr>
                  {Object.keys(item).map(col => {
                    return <Td style={{color:"red"}}>Row {item.row} : {item.message}</Td>
                  })}
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>

        }        




          <Row style={{color: "red", fontSize: "11px"}}>{this.state.errMsg}</Row>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme='blue' mr={3}
            disabled={((!this.state?.parsedResult) || (this.state.hasImportErrors))}
            onClick={(e) => this.onOkButtonClick(e)}
          >
            Ok
          </Button>
          <Button
            colorScheme='blue' mr={3}
            onClick={(e) => this.onCloseRequest(e)}
          >
            Cancel
          </Button>
          <div>
            {savingDiv}
          </div>
        </ModalFooter>
        </ModalContent>
      </Modal>
      : <span/>
    );
  }
}
